import * as yup from "yup";

export const isEmpty = (value: any) =>
	value === null || value === undefined || value === "";
export const AccountOrBankDetailsValidationSchema = yup.object().shape({
	accTitle: yup
		.string()
		.required("Accountant Title is required")
		.min(1, "Minimum length 1 characters")
		.max(50, "Maximum length 50 characters"),
	firstName: yup
		.string()
		.required("First Name is required")
		.min(1, "Minimum length 1 characters")
		.max(30, "Maximum length 30 characters"),
	lastName: yup
		.string()
		.required("Last Name is required")
		.min(1, "Minimum length 1 characters")
		.max(30, "Maximum length 30 characters"),
	initial: yup.string().max(3, "Maximum length 3 characters"),
	addressLine1: yup
		.string()
		.required("Address is required")
		.min(1, "Minimum length 1 characters")
		.max(100, "Maximum length 100 characters"),
	city: yup
		.string()
		.required("City is required")
		.min(1, "Minimum length 1 characters")
		.max(30, "Maximum length 30 characters"),
	province: yup.string().required("Province is required"),
	country: yup.string().required("Country is required"),
	phone: yup.string().required("Phone is required"),
	// email: yup
	// 	.string()
	// 	.email("Must be a valid email address")
	// 	.required("Email is required")
	// 	.max(100, "Maximum length 100 characters"),
	email: yup
		.string()
		.trim()
		.required("Email is required")
		.email("Must be a valid email address")
		// .matches(/\.[A-Za-z]{2,}$/, "Must be a valid email address")
		.matches(/\.[A-Za-z]{2,}$/, {
			message: "Must be a valid email address",
			excludeEmptyString: true,
		})
		.max(100, "Maximum length 100 characters"),

	// BANK

	accountNo: yup
		.string()
		.nullable()
		.test(
			"bank-fields-required",
			"Bank Account No. is required",
			function (value) {
				const { account1Name, branchTransitNumber, bankFinancialNo } =
					this.parent;
				const anyFilled =
					!isEmpty(account1Name) ||
					!isEmpty(branchTransitNumber) ||
					!isEmpty(bankFinancialNo);

				if (anyFilled && isEmpty(value)) return false;
				return true;
			},
		),

	branchTransitNumber: yup
		.string()
		.nullable()
		.test(
			"bank-fields-required",
			"Branch / Transit No. is required",
			function (value) {
				const { account1Name, accountNo, bankFinancialNo } = this.parent;
				const anyFilled =
					!isEmpty(account1Name) ||
					!isEmpty(accountNo) ||
					!isEmpty(bankFinancialNo);

				if (anyFilled && isEmpty(value)) return false;
				return true;
			},
		),

	bankFinancialNo: yup
		.string()
		.nullable()
		.test(
			"bank-fields-required",
			"Bank / Fin Institution No. is required",
			function (value) {
				const { account1Name, accountNo, branchTransitNumber } = this.parent;
				const anyFilled =
					!isEmpty(account1Name) ||
					!isEmpty(accountNo) ||
					!isEmpty(branchTransitNumber);

				if (anyFilled && isEmpty(value)) return false;
				return true;
			},
		),
});
